export default __webpack_public_path__ + "static/media/677.2649295f.jpg";